<template>
<div></div>
</template>

<script>
export default {
  name: 'SimulationPractice'
}
</script>

<style scoped>

</style>
